(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-slider"] && !Shopify.designMode) return;
  try {
    
// Initialize Slick slider
$(document).ready(function(){
  $('.logo-slider').each(function() {
    var $slider = $(this);
    var slidesToShow = parseInt($slider.data('slides-to-show'), 10);
    var slidesToScroll = parseInt($slider.data('slides-to-scroll'), 10);
    var showDots = $slider.data('show-dots') === 'true';
    var autoplaySpeed = parseInt($slider.data('autoplay-speed'), 10);
    $slider.slick({
      dots: showDots,
      infinite: true,
      speed: 300,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToScroll,
      autoplay: true,
      autoplaySpeed: autoplaySpeed,
      prevArrow: '<button type="button" aria-label="Prev" class="slick-prev"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
      nextArrow: '<button type="button" aria-label="Next" class="slick-next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow:3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
